import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-763f14bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "grid" }
const _hoisted_2 = {
  id: "export-modal",
  style: {"display":"none"},
  class: "modal-bg"
}
const _hoisted_3 = { class: "modal-inner-container" }
const _hoisted_4 = { class: "modal" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("textarea", {
  id: "export",
  readonly: ""
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "modal-bg"
}
const _hoisted_7 = { class: "modal-inner-container" }
const _hoisted_8 = { class: "modal" }
const _hoisted_9 = { ref: "import-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn m-2 btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.importVisible = true))
    }, " Import "),
    _createElementVNode("div", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn m-2 btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
            }, " Close ")
          ])
        ])
      ])
    ]),
    (_ctx.importVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("textarea", _hoisted_9, null, 512),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn m-2 btn-primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.importVisible = false))
                }, " Close "),
                _createElementVNode("button", {
                  class: "btn m-2 btn-primary",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.importVals && _ctx.importVals(...args)))
                }, " Import ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}